// ─────────────────────────────────────────────────────────────────────────────
// Paridad F1 (H-13) — componente de presentación para la familia .platform-banner*
// del demo (PlataformaPage.tsx : 406-434). Solo CSS + presentación: qué
// disparador de negocio lo muestra (nuevo reconocimiento, racha en riesgo,
// campaña por terminar, etc.) se decide en la fase que integre cada caso de uso
// real; aquí no se porta ninguna lógica de "escenarios de demo" (regla 7).
// ─────────────────────────────────────────────────────────────────────────────
import type { ReactNode } from 'react';

export type PlatformBannerVariant = 'success' | 'warning' | 'info';

interface PlatformBannerProps {
  variant: PlatformBannerVariant;
  children: ReactNode;
  onClose: () => void;
}

export function PlatformBanner({ variant, children, onClose }: Readonly<PlatformBannerProps>) {
  return (
    <div className={`platform-banner platform-banner--${variant}`}>
      <span className="platform-banner-text">{children}</span>
      <button type="button" className="platform-banner-close" onClick={onClose} aria-label="close">
        <i className="fas fa-times" aria-hidden="true" />
      </button>
    </div>
  );
}
